import moment from 'moment-timezone';

import createSelector from 'web-app/util/custom-create-selector';
import ProductsAndSessionsBehaviors from 'web-app/behaviors/products-and-sessions-behavior-ids';

const validTo = (_, props) =>
    props && props.validTo && moment.isMoment(props.validTo) ? props.validTo.clone() : moment().startOf('day');

const validFrom = (_, props) =>
    props && props.validFrom && moment.isMoment(props.validFrom) ? props.validFrom.clone() : moment();

const dayFromProps = (_, props) => (props ? props.day : null);

const productIdFromProps = (_, props) => (props ? props.productId : null);

export const getProductsState = state => state.entities.products;
export const getBehaviorState = state => state.entities.productBehaviors;

export const getAllProductVersions = createSelector(getProductsState, productIdFromProps, (products, productId) =>
    products
        .filter(product => product.productId === productId)
        .toList()
        .sortBy(product => product.validFrom.toDate()),
);

export const getValidProducts = createSelector(getProductsState, validTo, validFrom, (products, validTo, validFrom) =>
    products.filter(s => {
        const to = s.validTo ? s.validTo.isAfter(validTo) : true;
        const from = s.validFrom ? s.validFrom.isSameOrBefore(validFrom) : true;
        return from && to;
    }),
);

export const getProducts = createSelector(getValidProducts, products => products.toList());

export const getProductsInADay = createSelector(getProducts, dayFromProps, (products, day) =>
    products.filter(s => s.availability.some(av => av === day)),
);

export const makeGetProductByProps = () => {
    return createSelector(
        getProductsState,
        (state, props) => props.productVersion,
        (products, itemId) => products.get(itemId),
    );
};

export const showWeekends = createSelector(getBehaviorState, behaviors =>
    behaviors.includes(ProductsAndSessionsBehaviors.ShowWeekend),
);

export const getProductByProps = makeGetProductByProps();

export const getProductById = (() =>
    createSelector(
        getProductsState,
        (state, props) => props.productId,
        (products, productId) => products.find(product => product.productId === productId),
    ))();
